export default {
      id: "help-usage",
      viewBox: "0 0 24 24",
      url: "assets/" + "sprite.svg#help-usage",
      toString: function () {
        return this.url;
      }
    }